import { j as Lr } from "../../jsx-runtime-C5mzlN2N.js";
import { c as ar, g as Rr } from "../../_commonjsHelpers-DaMA6jEr.js";
import { useMemo as qr, useEffect as Dr } from "react";
import { L as Mr } from "../../hooks-DPYWRxPn.js";
import { u as jr } from "../../hooks-DPYWRxPn.js";
import { originalConsoleError as N, originalConsoleWarn as Y, originalConsoleInfo as $ } from "./utils.es.js";
var X, hr;
function kr() {
  if (hr) return X;
  hr = 1, X = function(y, g, F) {
    const v = '{"Events":[', l = "]}", o = new y([v]).size + new y([l]).size;
    class T {
      constructor(h) {
        let f = {
          serverUrl: "http://localhost:5341",
          apiKey: null,
          maxBatchingTime: 2e3,
          eventSizeLimit: 262144,
          batchSizeLimit: 1048576,
          requestTimeout: 3e4,
          maxRetries: 5,
          retryDelay: 5e3,
          onError: (c) => {
            console.error("[seq]", c);
          }
        }, w = h || f;
        var s = w.serverUrl || f.serverUrl;
        s.endsWith("/") || (s += "/"), this._endpoint = s + "api/events/raw", this._apiKey = w.apiKey || f.apiKey, this._maxBatchingTime = w.maxBatchingTime || f.maxBatchingTime, this._eventSizeLimit = w.eventSizeLimit || f.eventSizeLimit, this._batchSizeLimit = w.batchSizeLimit || f.batchSizeLimit, this._requestTimeout = w.requestTimeout || f.requestTimeout, this._onError = w.onError || f.onError, this._maxRetries = w.maxRetries || f.maxRetries, this._retryDelay = w.retryDelay || f.retryDelay, this._queue = [], this._timer = null, this._closed = !1, this._activeShipper = null;
      }
      /**
       * Flush events queued at the time of the call, and wait for pending writes to complete regardless of configured batching/timers.
       * @returns {Promise<boolean>}
       */
      flush() {
        return this._ship();
      }
      /**
       * Flush then destroy connections, close the logger, destroying timers and other resources.
       * @returns {Promise<void>}
       */
      close() {
        if (this._closed)
          throw new Error("The logger has already been closed.");
        return this._closed = !0, this._clearTimer(), this.flush();
      }
      /**
       * Enqueue an event in Seq format.
       * @param {*} event
       * @returns {void}
       */
      emit(h) {
        if (!h)
          throw new Error("An event must be provided");
        if (this._closed)
          return;
        let f = this._toWireFormat(h);
        this._queue.push(f), this._activeShipper || this._setTimer();
      }
      _setTimer() {
        this._timer === null && (this._timer = setTimeout(() => {
          this._timer = null, this._onTimer();
        }, this._maxBatchingTime));
      }
      _clearTimer() {
        this._timer !== null && (clearTimeout(this._timer), this._timer = null);
      }
      _onTimer() {
        this._activeShipper || this._ship();
      }
      _toWireFormat(h) {
        var d, _;
        const f = typeof h.level == "string" ? h.level : void 0, w = h.timestamp instanceof Date ? h.timestamp : /* @__PURE__ */ new Date(), s = typeof h.messageTemplate == "string" ? h.messageTemplate : h.messageTemplate !== null && h.messageTemplate !== void 0 ? h.messageTemplate.toString() : "(No message provided)", c = typeof h.exception == "string" ? h.exception : h.exception !== null && h.exception !== void 0 ? h.exception.toString() : void 0, m = typeof h.properties == "object" ? h.properties : void 0;
        return {
          Timestamp: w,
          Level: f,
          TraceId: (d = h.traceId) == null ? void 0 : d.toString(),
          SpanId: (_ = h.spanId) == null ? void 0 : _.toString(),
          MessageTemplate: s,
          Exception: c,
          Properties: m
        };
      }
      _eventTooLargeErrorEvent(h) {
        return {
          Timestamp: h.Timestamp,
          Level: h.Level,
          MessageTemplate: "(Event too large) {initial}...",
          Properties: {
            initial: h.MessageTemplate.substring(0, 12),
            sourceContext: "Seq Javascript Client",
            eventSizeLimit: this._eventSizeLimit
          }
        };
      }
      _reset(h) {
        this._activeShipper === h && (this._activeShipper = null, this._queue.length !== 0 && this._setTimer());
      }
      /**
       *
       * @returns {Promise<boolean>}
       */
      _ship() {
        if (this._queue.length === 0)
          return Promise.resolve(!1);
        let h = this._activeShipper || Promise.resolve(!1), f = this._activeShipper = h.then(() => {
          let w = (s) => s ? !0 : this._sendBatch().then((c) => w(c));
          return this._sendBatch().then((s) => w(s));
        }).then(() => this._reset(f), (w) => {
          this._onError(w), this._reset(f);
        });
        return f;
      }
      _sendBatch() {
        if (this._queue.length === 0)
          return Promise.resolve(!0);
        let h = this._dequeBatch(), f = this._queue.length === 0;
        return this._post(h.batch, h.bytes).then(() => f);
      }
      _dequeBatch() {
        var h = o;
        let f = [];
        for (var w = 0, s = 0; w < this._queue.length; ) {
          let m = this._queue[w], d;
          try {
            d = JSON.stringify(m);
          } catch {
            const A = p(m);
            d = JSON.stringify(A), this.emit({
              timestamp: A.Timestamp,
              level: "Error",
              messageTemplate: "[seq] Circular structure found"
            });
          }
          var c = new y([d]).size;
          if (c > this._eventSizeLimit && (this._onError("[seq] Event body is larger than " + this._eventSizeLimit + " bytes: " + d), this._queue[w] = m = this._eventTooLargeErrorEvent(m), d = JSON.stringify(m), c = new y([d]).size), w !== 0 && h + c + s > this._batchSizeLimit)
            break;
          w = w + 1, h += c + s, s = 1, f.push(d);
        }
        return this._queue.splice(0, w), { batch: f, bytes: h };
      }
      _httpOrNetworkError(h) {
        return ["ECONNRESET", "ENOTFOUND", "ESOCKETTIMEDOUT", "ETIMEDOUT", "ECONNREFUSED", "EHOSTUNREACH", "EPIPE", "EAI_AGAIN", "EBUSY"].includes(h) || 500 <= h.status && h.status < 600;
      }
      _post(h, f) {
        let w = 0;
        return new Promise((s, c) => {
          const m = (d, _) => {
            const A = new F();
            w++;
            const L = setTimeout(() => {
              A.abort(), w > this._maxRetries ? c("HTTP log shipping failed, reached timeout (" + this._requestTimeout + " ms)") : setTimeout(() => m(d, _), this._retryDelay);
            }, this._requestTimeout);
            g(this._endpoint, {
              keepalive: !0,
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "X-Seq-ApiKey": this._apiKey ? this._apiKey : null,
                "Content-Length": _
              },
              body: `${v}${d.join(",")}${l}`,
              signal: A.signal
            }).then((D) => {
              clearTimeout(L);
              let I = null;
              return D.status !== 200 && D.status !== 201 ? (I = "HTTP log shipping failed: " + D.status, this._httpOrNetworkError(D) && w < this._maxRetries ? setTimeout(() => m(d, _), this._retryDelay) : c(I)) : s(!0);
            }).catch((D) => {
              clearTimeout(L), c(D);
            });
          };
          return m(h, f);
        });
      }
    }
    return T;
  };
  const x = (y) => !y || typeof y != "object", p = (y, g = /* @__PURE__ */ new Map(), F = "root") => {
    if (x(y)) return y;
    if (g.has(y))
      return "== Circular structure: '" + g.get(y).replace("root.Properties.", "") + "' ==";
    if (g.set(y, F), y instanceof Array)
      return y.map(
        (o, T) => x(o) ? o : p(o, new Map(g), F + `[${T}]`)
      );
    const v = Object.keys(y);
    if (v.length === 0)
      return y;
    const l = {};
    return v.forEach((o) => {
      const T = y[o];
      if (x(T)) {
        l[o] = T;
        return;
      }
      l[o] = p(T, new Map(g), F + "." + o);
    }), l;
  };
  return X;
}
var G = {}, b = {}, sr;
function Nr() {
  if (sr) return b;
  sr = 1, b.byteLength = o, b.toByteArray = C, b.fromByteArray = w;
  for (var x = [], p = [], y = typeof Uint8Array < "u" ? Uint8Array : Array, g = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", F = 0, v = g.length; F < v; ++F)
    x[F] = g[F], p[g.charCodeAt(F)] = F;
  p[45] = 62, p[95] = 63;
  function l(s) {
    var c = s.length;
    if (c % 4 > 0)
      throw new Error("Invalid string. Length must be a multiple of 4");
    var m = s.indexOf("=");
    m === -1 && (m = c);
    var d = m === c ? 0 : 4 - m % 4;
    return [m, d];
  }
  function o(s) {
    var c = l(s), m = c[0], d = c[1];
    return (m + d) * 3 / 4 - d;
  }
  function T(s, c, m) {
    return (c + m) * 3 / 4 - m;
  }
  function C(s) {
    var c, m = l(s), d = m[0], _ = m[1], A = new y(T(s, d, _)), L = 0, D = _ > 0 ? d - 4 : d, I;
    for (I = 0; I < D; I += 4)
      c = p[s.charCodeAt(I)] << 18 | p[s.charCodeAt(I + 1)] << 12 | p[s.charCodeAt(I + 2)] << 6 | p[s.charCodeAt(I + 3)], A[L++] = c >> 16 & 255, A[L++] = c >> 8 & 255, A[L++] = c & 255;
    return _ === 2 && (c = p[s.charCodeAt(I)] << 2 | p[s.charCodeAt(I + 1)] >> 4, A[L++] = c & 255), _ === 1 && (c = p[s.charCodeAt(I)] << 10 | p[s.charCodeAt(I + 1)] << 4 | p[s.charCodeAt(I + 2)] >> 2, A[L++] = c >> 8 & 255, A[L++] = c & 255), A;
  }
  function h(s) {
    return x[s >> 18 & 63] + x[s >> 12 & 63] + x[s >> 6 & 63] + x[s & 63];
  }
  function f(s, c, m) {
    for (var d, _ = [], A = c; A < m; A += 3)
      d = (s[A] << 16 & 16711680) + (s[A + 1] << 8 & 65280) + (s[A + 2] & 255), _.push(h(d));
    return _.join("");
  }
  function w(s) {
    for (var c, m = s.length, d = m % 3, _ = [], A = 16383, L = 0, D = m - d; L < D; L += A)
      _.push(f(s, L, L + A > D ? D : L + A));
    return d === 1 ? (c = s[m - 1], _.push(
      x[c >> 2] + x[c << 4 & 63] + "=="
    )) : d === 2 && (c = (s[m - 2] << 8) + s[m - 1], _.push(
      x[c >> 10] + x[c >> 4 & 63] + x[c << 2 & 63] + "="
    )), _.join("");
  }
  return b;
}
var H = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
var fr;
function br() {
  return fr || (fr = 1, H.read = function(x, p, y, g, F) {
    var v, l, o = F * 8 - g - 1, T = (1 << o) - 1, C = T >> 1, h = -7, f = y ? F - 1 : 0, w = y ? -1 : 1, s = x[p + f];
    for (f += w, v = s & (1 << -h) - 1, s >>= -h, h += o; h > 0; v = v * 256 + x[p + f], f += w, h -= 8)
      ;
    for (l = v & (1 << -h) - 1, v >>= -h, h += g; h > 0; l = l * 256 + x[p + f], f += w, h -= 8)
      ;
    if (v === 0)
      v = 1 - C;
    else {
      if (v === T)
        return l ? NaN : (s ? -1 : 1) * (1 / 0);
      l = l + Math.pow(2, g), v = v - C;
    }
    return (s ? -1 : 1) * l * Math.pow(2, v - g);
  }, H.write = function(x, p, y, g, F, v) {
    var l, o, T, C = v * 8 - F - 1, h = (1 << C) - 1, f = h >> 1, w = F === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, s = g ? 0 : v - 1, c = g ? 1 : -1, m = p < 0 || p === 0 && 1 / p < 0 ? 1 : 0;
    for (p = Math.abs(p), isNaN(p) || p === 1 / 0 ? (o = isNaN(p) ? 1 : 0, l = h) : (l = Math.floor(Math.log(p) / Math.LN2), p * (T = Math.pow(2, -l)) < 1 && (l--, T *= 2), l + f >= 1 ? p += w / T : p += w * Math.pow(2, 1 - f), p * T >= 2 && (l++, T /= 2), l + f >= h ? (o = 0, l = h) : l + f >= 1 ? (o = (p * T - 1) * Math.pow(2, F), l = l + f) : (o = p * Math.pow(2, f - 1) * Math.pow(2, F), l = 0)); F >= 8; x[y + s] = o & 255, s += c, o /= 256, F -= 8)
      ;
    for (l = l << F | o, C += F; C > 0; x[y + s] = l & 255, s += c, l /= 256, C -= 8)
      ;
    x[y + s - c] |= m * 128;
  }), H;
}
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
var pr;
function Or() {
  return pr || (pr = 1, function(x) {
    var p = Nr(), y = br(), g = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
    x.Buffer = o, x.SlowBuffer = A, x.INSPECT_MAX_BYTES = 50;
    var F = 2147483647;
    x.kMaxLength = F, o.TYPED_ARRAY_SUPPORT = v(), !o.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
      "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
    );
    function v() {
      try {
        var t = new Uint8Array(1), r = { foo: function() {
          return 42;
        } };
        return Object.setPrototypeOf(r, Uint8Array.prototype), Object.setPrototypeOf(t, r), t.foo() === 42;
      } catch {
        return !1;
      }
    }
    Object.defineProperty(o.prototype, "parent", {
      enumerable: !0,
      get: function() {
        if (o.isBuffer(this))
          return this.buffer;
      }
    }), Object.defineProperty(o.prototype, "offset", {
      enumerable: !0,
      get: function() {
        if (o.isBuffer(this))
          return this.byteOffset;
      }
    });
    function l(t) {
      if (t > F)
        throw new RangeError('The value "' + t + '" is invalid for option "size"');
      var r = new Uint8Array(t);
      return Object.setPrototypeOf(r, o.prototype), r;
    }
    function o(t, r, e) {
      if (typeof t == "number") {
        if (typeof r == "string")
          throw new TypeError(
            'The "string" argument must be of type string. Received type number'
          );
        return f(t);
      }
      return T(t, r, e);
    }
    o.poolSize = 8192;
    function T(t, r, e) {
      if (typeof t == "string")
        return w(t, r);
      if (ArrayBuffer.isView(t))
        return c(t);
      if (t == null)
        throw new TypeError(
          "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof t
        );
      if (k(t, ArrayBuffer) || t && k(t.buffer, ArrayBuffer) || typeof SharedArrayBuffer < "u" && (k(t, SharedArrayBuffer) || t && k(t.buffer, SharedArrayBuffer)))
        return m(t, r, e);
      if (typeof t == "number")
        throw new TypeError(
          'The "value" argument must not be of type number. Received type number'
        );
      var i = t.valueOf && t.valueOf();
      if (i != null && i !== t)
        return o.from(i, r, e);
      var n = d(t);
      if (n) return n;
      if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof t[Symbol.toPrimitive] == "function")
        return o.from(
          t[Symbol.toPrimitive]("string"),
          r,
          e
        );
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof t
      );
    }
    o.from = function(t, r, e) {
      return T(t, r, e);
    }, Object.setPrototypeOf(o.prototype, Uint8Array.prototype), Object.setPrototypeOf(o, Uint8Array);
    function C(t) {
      if (typeof t != "number")
        throw new TypeError('"size" argument must be of type number');
      if (t < 0)
        throw new RangeError('The value "' + t + '" is invalid for option "size"');
    }
    function h(t, r, e) {
      return C(t), t <= 0 ? l(t) : r !== void 0 ? typeof e == "string" ? l(t).fill(r, e) : l(t).fill(r) : l(t);
    }
    o.alloc = function(t, r, e) {
      return h(t, r, e);
    };
    function f(t) {
      return C(t), l(t < 0 ? 0 : _(t) | 0);
    }
    o.allocUnsafe = function(t) {
      return f(t);
    }, o.allocUnsafeSlow = function(t) {
      return f(t);
    };
    function w(t, r) {
      if ((typeof r != "string" || r === "") && (r = "utf8"), !o.isEncoding(r))
        throw new TypeError("Unknown encoding: " + r);
      var e = L(t, r) | 0, i = l(e), n = i.write(t, r);
      return n !== e && (i = i.slice(0, n)), i;
    }
    function s(t) {
      for (var r = t.length < 0 ? 0 : _(t.length) | 0, e = l(r), i = 0; i < r; i += 1)
        e[i] = t[i] & 255;
      return e;
    }
    function c(t) {
      if (k(t, Uint8Array)) {
        var r = new Uint8Array(t);
        return m(r.buffer, r.byteOffset, r.byteLength);
      }
      return s(t);
    }
    function m(t, r, e) {
      if (r < 0 || t.byteLength < r)
        throw new RangeError('"offset" is outside of buffer bounds');
      if (t.byteLength < r + (e || 0))
        throw new RangeError('"length" is outside of buffer bounds');
      var i;
      return r === void 0 && e === void 0 ? i = new Uint8Array(t) : e === void 0 ? i = new Uint8Array(t, r) : i = new Uint8Array(t, r, e), Object.setPrototypeOf(i, o.prototype), i;
    }
    function d(t) {
      if (o.isBuffer(t)) {
        var r = _(t.length) | 0, e = l(r);
        return e.length === 0 || t.copy(e, 0, 0, r), e;
      }
      if (t.length !== void 0)
        return typeof t.length != "number" || J(t.length) ? l(0) : s(t);
      if (t.type === "Buffer" && Array.isArray(t.data))
        return s(t.data);
    }
    function _(t) {
      if (t >= F)
        throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + F.toString(16) + " bytes");
      return t | 0;
    }
    function A(t) {
      return +t != t && (t = 0), o.alloc(+t);
    }
    o.isBuffer = function(r) {
      return r != null && r._isBuffer === !0 && r !== o.prototype;
    }, o.compare = function(r, e) {
      if (k(r, Uint8Array) && (r = o.from(r, r.offset, r.byteLength)), k(e, Uint8Array) && (e = o.from(e, e.offset, e.byteLength)), !o.isBuffer(r) || !o.isBuffer(e))
        throw new TypeError(
          'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
        );
      if (r === e) return 0;
      for (var i = r.length, n = e.length, u = 0, a = Math.min(i, n); u < a; ++u)
        if (r[u] !== e[u]) {
          i = r[u], n = e[u];
          break;
        }
      return i < n ? -1 : n < i ? 1 : 0;
    }, o.isEncoding = function(r) {
      switch (String(r).toLowerCase()) {
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return !0;
        default:
          return !1;
      }
    }, o.concat = function(r, e) {
      if (!Array.isArray(r))
        throw new TypeError('"list" argument must be an Array of Buffers');
      if (r.length === 0)
        return o.alloc(0);
      var i;
      if (e === void 0)
        for (e = 0, i = 0; i < r.length; ++i)
          e += r[i].length;
      var n = o.allocUnsafe(e), u = 0;
      for (i = 0; i < r.length; ++i) {
        var a = r[i];
        if (k(a, Uint8Array))
          u + a.length > n.length ? o.from(a).copy(n, u) : Uint8Array.prototype.set.call(
            n,
            a,
            u
          );
        else if (o.isBuffer(a))
          a.copy(n, u);
        else
          throw new TypeError('"list" argument must be an Array of Buffers');
        u += a.length;
      }
      return n;
    };
    function L(t, r) {
      if (o.isBuffer(t))
        return t.length;
      if (ArrayBuffer.isView(t) || k(t, ArrayBuffer))
        return t.byteLength;
      if (typeof t != "string")
        throw new TypeError(
          'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof t
        );
      var e = t.length, i = arguments.length > 2 && arguments[2] === !0;
      if (!i && e === 0) return 0;
      for (var n = !1; ; )
        switch (r) {
          case "ascii":
          case "latin1":
          case "binary":
            return e;
          case "utf8":
          case "utf-8":
            return K(t).length;
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return e * 2;
          case "hex":
            return e >>> 1;
          case "base64":
            return nr(t).length;
          default:
            if (n)
              return i ? -1 : K(t).length;
            r = ("" + r).toLowerCase(), n = !0;
        }
    }
    o.byteLength = L;
    function D(t, r, e) {
      var i = !1;
      if ((r === void 0 || r < 0) && (r = 0), r > this.length || ((e === void 0 || e > this.length) && (e = this.length), e <= 0) || (e >>>= 0, r >>>= 0, e <= r))
        return "";
      for (t || (t = "utf8"); ; )
        switch (t) {
          case "hex":
            return Tr(this, r, e);
          case "utf8":
          case "utf-8":
            return j(this, r, e);
          case "ascii":
            return Br(this, r, e);
          case "latin1":
          case "binary":
            return vr(this, r, e);
          case "base64":
            return dr(this, r, e);
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return Ar(this, r, e);
          default:
            if (i) throw new TypeError("Unknown encoding: " + t);
            t = (t + "").toLowerCase(), i = !0;
        }
    }
    o.prototype._isBuffer = !0;
    function I(t, r, e) {
      var i = t[r];
      t[r] = t[e], t[e] = i;
    }
    o.prototype.swap16 = function() {
      var r = this.length;
      if (r % 2 !== 0)
        throw new RangeError("Buffer size must be a multiple of 16-bits");
      for (var e = 0; e < r; e += 2)
        I(this, e, e + 1);
      return this;
    }, o.prototype.swap32 = function() {
      var r = this.length;
      if (r % 4 !== 0)
        throw new RangeError("Buffer size must be a multiple of 32-bits");
      for (var e = 0; e < r; e += 4)
        I(this, e, e + 3), I(this, e + 1, e + 2);
      return this;
    }, o.prototype.swap64 = function() {
      var r = this.length;
      if (r % 8 !== 0)
        throw new RangeError("Buffer size must be a multiple of 64-bits");
      for (var e = 0; e < r; e += 8)
        I(this, e, e + 7), I(this, e + 1, e + 6), I(this, e + 2, e + 5), I(this, e + 3, e + 4);
      return this;
    }, o.prototype.toString = function() {
      var r = this.length;
      return r === 0 ? "" : arguments.length === 0 ? j(this, 0, r) : D.apply(this, arguments);
    }, o.prototype.toLocaleString = o.prototype.toString, o.prototype.equals = function(r) {
      if (!o.isBuffer(r)) throw new TypeError("Argument must be a Buffer");
      return this === r ? !0 : o.compare(this, r) === 0;
    }, o.prototype.inspect = function() {
      var r = "", e = x.INSPECT_MAX_BYTES;
      return r = this.toString("hex", 0, e).replace(/(.{2})/g, "$1 ").trim(), this.length > e && (r += " ... "), "<Buffer " + r + ">";
    }, g && (o.prototype[g] = o.prototype.inspect), o.prototype.compare = function(r, e, i, n, u) {
      if (k(r, Uint8Array) && (r = o.from(r, r.offset, r.byteLength)), !o.isBuffer(r))
        throw new TypeError(
          'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof r
        );
      if (e === void 0 && (e = 0), i === void 0 && (i = r ? r.length : 0), n === void 0 && (n = 0), u === void 0 && (u = this.length), e < 0 || i > r.length || n < 0 || u > this.length)
        throw new RangeError("out of range index");
      if (n >= u && e >= i)
        return 0;
      if (n >= u)
        return -1;
      if (e >= i)
        return 1;
      if (e >>>= 0, i >>>= 0, n >>>= 0, u >>>= 0, this === r) return 0;
      for (var a = u - n, E = i - e, B = Math.min(a, E), U = this.slice(n, u), q = r.slice(e, i), S = 0; S < B; ++S)
        if (U[S] !== q[S]) {
          a = U[S], E = q[S];
          break;
        }
      return a < E ? -1 : E < a ? 1 : 0;
    };
    function Z(t, r, e, i, n) {
      if (t.length === 0) return -1;
      if (typeof e == "string" ? (i = e, e = 0) : e > 2147483647 ? e = 2147483647 : e < -2147483648 && (e = -2147483648), e = +e, J(e) && (e = n ? 0 : t.length - 1), e < 0 && (e = t.length + e), e >= t.length) {
        if (n) return -1;
        e = t.length - 1;
      } else if (e < 0)
        if (n) e = 0;
        else return -1;
      if (typeof r == "string" && (r = o.from(r, i)), o.isBuffer(r))
        return r.length === 0 ? -1 : Q(t, r, e, i, n);
      if (typeof r == "number")
        return r = r & 255, typeof Uint8Array.prototype.indexOf == "function" ? n ? Uint8Array.prototype.indexOf.call(t, r, e) : Uint8Array.prototype.lastIndexOf.call(t, r, e) : Q(t, [r], e, i, n);
      throw new TypeError("val must be string, number or Buffer");
    }
    function Q(t, r, e, i, n) {
      var u = 1, a = t.length, E = r.length;
      if (i !== void 0 && (i = String(i).toLowerCase(), i === "ucs2" || i === "ucs-2" || i === "utf16le" || i === "utf-16le")) {
        if (t.length < 2 || r.length < 2)
          return -1;
        u = 2, a /= 2, E /= 2, e /= 2;
      }
      function B(or, ur) {
        return u === 1 ? or[ur] : or.readUInt16BE(ur * u);
      }
      var U;
      if (n) {
        var q = -1;
        for (U = e; U < a; U++)
          if (B(t, U) === B(r, q === -1 ? 0 : U - q)) {
            if (q === -1 && (q = U), U - q + 1 === E) return q * u;
          } else
            q !== -1 && (U -= U - q), q = -1;
      } else
        for (e + E > a && (e = a - E), U = e; U >= 0; U--) {
          for (var S = !0, W = 0; W < E; W++)
            if (B(t, U + W) !== B(r, W)) {
              S = !1;
              break;
            }
          if (S) return U;
        }
      return -1;
    }
    o.prototype.includes = function(r, e, i) {
      return this.indexOf(r, e, i) !== -1;
    }, o.prototype.indexOf = function(r, e, i) {
      return Z(this, r, e, i, !0);
    }, o.prototype.lastIndexOf = function(r, e, i) {
      return Z(this, r, e, i, !1);
    };
    function yr(t, r, e, i) {
      e = Number(e) || 0;
      var n = t.length - e;
      i ? (i = Number(i), i > n && (i = n)) : i = n;
      var u = r.length;
      i > u / 2 && (i = u / 2);
      for (var a = 0; a < i; ++a) {
        var E = parseInt(r.substr(a * 2, 2), 16);
        if (J(E)) return a;
        t[e + a] = E;
      }
      return a;
    }
    function mr(t, r, e, i) {
      return z(K(r, t.length - e), t, e, i);
    }
    function xr(t, r, e, i) {
      return z(Ir(r), t, e, i);
    }
    function Er(t, r, e, i) {
      return z(nr(r), t, e, i);
    }
    function gr(t, r, e, i) {
      return z(Sr(r, t.length - e), t, e, i);
    }
    o.prototype.write = function(r, e, i, n) {
      if (e === void 0)
        n = "utf8", i = this.length, e = 0;
      else if (i === void 0 && typeof e == "string")
        n = e, i = this.length, e = 0;
      else if (isFinite(e))
        e = e >>> 0, isFinite(i) ? (i = i >>> 0, n === void 0 && (n = "utf8")) : (n = i, i = void 0);
      else
        throw new Error(
          "Buffer.write(string, encoding, offset[, length]) is no longer supported"
        );
      var u = this.length - e;
      if ((i === void 0 || i > u) && (i = u), r.length > 0 && (i < 0 || e < 0) || e > this.length)
        throw new RangeError("Attempt to write outside buffer bounds");
      n || (n = "utf8");
      for (var a = !1; ; )
        switch (n) {
          case "hex":
            return yr(this, r, e, i);
          case "utf8":
          case "utf-8":
            return mr(this, r, e, i);
          case "ascii":
          case "latin1":
          case "binary":
            return xr(this, r, e, i);
          case "base64":
            return Er(this, r, e, i);
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return gr(this, r, e, i);
          default:
            if (a) throw new TypeError("Unknown encoding: " + n);
            n = ("" + n).toLowerCase(), a = !0;
        }
    }, o.prototype.toJSON = function() {
      return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
      };
    };
    function dr(t, r, e) {
      return r === 0 && e === t.length ? p.fromByteArray(t) : p.fromByteArray(t.slice(r, e));
    }
    function j(t, r, e) {
      e = Math.min(t.length, e);
      for (var i = [], n = r; n < e; ) {
        var u = t[n], a = null, E = u > 239 ? 4 : u > 223 ? 3 : u > 191 ? 2 : 1;
        if (n + E <= e) {
          var B, U, q, S;
          switch (E) {
            case 1:
              u < 128 && (a = u);
              break;
            case 2:
              B = t[n + 1], (B & 192) === 128 && (S = (u & 31) << 6 | B & 63, S > 127 && (a = S));
              break;
            case 3:
              B = t[n + 1], U = t[n + 2], (B & 192) === 128 && (U & 192) === 128 && (S = (u & 15) << 12 | (B & 63) << 6 | U & 63, S > 2047 && (S < 55296 || S > 57343) && (a = S));
              break;
            case 4:
              B = t[n + 1], U = t[n + 2], q = t[n + 3], (B & 192) === 128 && (U & 192) === 128 && (q & 192) === 128 && (S = (u & 15) << 18 | (B & 63) << 12 | (U & 63) << 6 | q & 63, S > 65535 && S < 1114112 && (a = S));
          }
        }
        a === null ? (a = 65533, E = 1) : a > 65535 && (a -= 65536, i.push(a >>> 10 & 1023 | 55296), a = 56320 | a & 1023), i.push(a), n += E;
      }
      return Fr(i);
    }
    var rr = 4096;
    function Fr(t) {
      var r = t.length;
      if (r <= rr)
        return String.fromCharCode.apply(String, t);
      for (var e = "", i = 0; i < r; )
        e += String.fromCharCode.apply(
          String,
          t.slice(i, i += rr)
        );
      return e;
    }
    function Br(t, r, e) {
      var i = "";
      e = Math.min(t.length, e);
      for (var n = r; n < e; ++n)
        i += String.fromCharCode(t[n] & 127);
      return i;
    }
    function vr(t, r, e) {
      var i = "";
      e = Math.min(t.length, e);
      for (var n = r; n < e; ++n)
        i += String.fromCharCode(t[n]);
      return i;
    }
    function Tr(t, r, e) {
      var i = t.length;
      (!r || r < 0) && (r = 0), (!e || e < 0 || e > i) && (e = i);
      for (var n = "", u = r; u < e; ++u)
        n += Cr[t[u]];
      return n;
    }
    function Ar(t, r, e) {
      for (var i = t.slice(r, e), n = "", u = 0; u < i.length - 1; u += 2)
        n += String.fromCharCode(i[u] + i[u + 1] * 256);
      return n;
    }
    o.prototype.slice = function(r, e) {
      var i = this.length;
      r = ~~r, e = e === void 0 ? i : ~~e, r < 0 ? (r += i, r < 0 && (r = 0)) : r > i && (r = i), e < 0 ? (e += i, e < 0 && (e = 0)) : e > i && (e = i), e < r && (e = r);
      var n = this.subarray(r, e);
      return Object.setPrototypeOf(n, o.prototype), n;
    };
    function R(t, r, e) {
      if (t % 1 !== 0 || t < 0) throw new RangeError("offset is not uint");
      if (t + r > e) throw new RangeError("Trying to access beyond buffer length");
    }
    o.prototype.readUintLE = o.prototype.readUIntLE = function(r, e, i) {
      r = r >>> 0, e = e >>> 0, i || R(r, e, this.length);
      for (var n = this[r], u = 1, a = 0; ++a < e && (u *= 256); )
        n += this[r + a] * u;
      return n;
    }, o.prototype.readUintBE = o.prototype.readUIntBE = function(r, e, i) {
      r = r >>> 0, e = e >>> 0, i || R(r, e, this.length);
      for (var n = this[r + --e], u = 1; e > 0 && (u *= 256); )
        n += this[r + --e] * u;
      return n;
    }, o.prototype.readUint8 = o.prototype.readUInt8 = function(r, e) {
      return r = r >>> 0, e || R(r, 1, this.length), this[r];
    }, o.prototype.readUint16LE = o.prototype.readUInt16LE = function(r, e) {
      return r = r >>> 0, e || R(r, 2, this.length), this[r] | this[r + 1] << 8;
    }, o.prototype.readUint16BE = o.prototype.readUInt16BE = function(r, e) {
      return r = r >>> 0, e || R(r, 2, this.length), this[r] << 8 | this[r + 1];
    }, o.prototype.readUint32LE = o.prototype.readUInt32LE = function(r, e) {
      return r = r >>> 0, e || R(r, 4, this.length), (this[r] | this[r + 1] << 8 | this[r + 2] << 16) + this[r + 3] * 16777216;
    }, o.prototype.readUint32BE = o.prototype.readUInt32BE = function(r, e) {
      return r = r >>> 0, e || R(r, 4, this.length), this[r] * 16777216 + (this[r + 1] << 16 | this[r + 2] << 8 | this[r + 3]);
    }, o.prototype.readIntLE = function(r, e, i) {
      r = r >>> 0, e = e >>> 0, i || R(r, e, this.length);
      for (var n = this[r], u = 1, a = 0; ++a < e && (u *= 256); )
        n += this[r + a] * u;
      return u *= 128, n >= u && (n -= Math.pow(2, 8 * e)), n;
    }, o.prototype.readIntBE = function(r, e, i) {
      r = r >>> 0, e = e >>> 0, i || R(r, e, this.length);
      for (var n = e, u = 1, a = this[r + --n]; n > 0 && (u *= 256); )
        a += this[r + --n] * u;
      return u *= 128, a >= u && (a -= Math.pow(2, 8 * e)), a;
    }, o.prototype.readInt8 = function(r, e) {
      return r = r >>> 0, e || R(r, 1, this.length), this[r] & 128 ? (255 - this[r] + 1) * -1 : this[r];
    }, o.prototype.readInt16LE = function(r, e) {
      r = r >>> 0, e || R(r, 2, this.length);
      var i = this[r] | this[r + 1] << 8;
      return i & 32768 ? i | 4294901760 : i;
    }, o.prototype.readInt16BE = function(r, e) {
      r = r >>> 0, e || R(r, 2, this.length);
      var i = this[r + 1] | this[r] << 8;
      return i & 32768 ? i | 4294901760 : i;
    }, o.prototype.readInt32LE = function(r, e) {
      return r = r >>> 0, e || R(r, 4, this.length), this[r] | this[r + 1] << 8 | this[r + 2] << 16 | this[r + 3] << 24;
    }, o.prototype.readInt32BE = function(r, e) {
      return r = r >>> 0, e || R(r, 4, this.length), this[r] << 24 | this[r + 1] << 16 | this[r + 2] << 8 | this[r + 3];
    }, o.prototype.readFloatLE = function(r, e) {
      return r = r >>> 0, e || R(r, 4, this.length), y.read(this, r, !0, 23, 4);
    }, o.prototype.readFloatBE = function(r, e) {
      return r = r >>> 0, e || R(r, 4, this.length), y.read(this, r, !1, 23, 4);
    }, o.prototype.readDoubleLE = function(r, e) {
      return r = r >>> 0, e || R(r, 8, this.length), y.read(this, r, !0, 52, 8);
    }, o.prototype.readDoubleBE = function(r, e) {
      return r = r >>> 0, e || R(r, 8, this.length), y.read(this, r, !1, 52, 8);
    };
    function M(t, r, e, i, n, u) {
      if (!o.isBuffer(t)) throw new TypeError('"buffer" argument must be a Buffer instance');
      if (r > n || r < u) throw new RangeError('"value" argument is out of bounds');
      if (e + i > t.length) throw new RangeError("Index out of range");
    }
    o.prototype.writeUintLE = o.prototype.writeUIntLE = function(r, e, i, n) {
      if (r = +r, e = e >>> 0, i = i >>> 0, !n) {
        var u = Math.pow(2, 8 * i) - 1;
        M(this, r, e, i, u, 0);
      }
      var a = 1, E = 0;
      for (this[e] = r & 255; ++E < i && (a *= 256); )
        this[e + E] = r / a & 255;
      return e + i;
    }, o.prototype.writeUintBE = o.prototype.writeUIntBE = function(r, e, i, n) {
      if (r = +r, e = e >>> 0, i = i >>> 0, !n) {
        var u = Math.pow(2, 8 * i) - 1;
        M(this, r, e, i, u, 0);
      }
      var a = i - 1, E = 1;
      for (this[e + a] = r & 255; --a >= 0 && (E *= 256); )
        this[e + a] = r / E & 255;
      return e + i;
    }, o.prototype.writeUint8 = o.prototype.writeUInt8 = function(r, e, i) {
      return r = +r, e = e >>> 0, i || M(this, r, e, 1, 255, 0), this[e] = r & 255, e + 1;
    }, o.prototype.writeUint16LE = o.prototype.writeUInt16LE = function(r, e, i) {
      return r = +r, e = e >>> 0, i || M(this, r, e, 2, 65535, 0), this[e] = r & 255, this[e + 1] = r >>> 8, e + 2;
    }, o.prototype.writeUint16BE = o.prototype.writeUInt16BE = function(r, e, i) {
      return r = +r, e = e >>> 0, i || M(this, r, e, 2, 65535, 0), this[e] = r >>> 8, this[e + 1] = r & 255, e + 2;
    }, o.prototype.writeUint32LE = o.prototype.writeUInt32LE = function(r, e, i) {
      return r = +r, e = e >>> 0, i || M(this, r, e, 4, 4294967295, 0), this[e + 3] = r >>> 24, this[e + 2] = r >>> 16, this[e + 1] = r >>> 8, this[e] = r & 255, e + 4;
    }, o.prototype.writeUint32BE = o.prototype.writeUInt32BE = function(r, e, i) {
      return r = +r, e = e >>> 0, i || M(this, r, e, 4, 4294967295, 0), this[e] = r >>> 24, this[e + 1] = r >>> 16, this[e + 2] = r >>> 8, this[e + 3] = r & 255, e + 4;
    }, o.prototype.writeIntLE = function(r, e, i, n) {
      if (r = +r, e = e >>> 0, !n) {
        var u = Math.pow(2, 8 * i - 1);
        M(this, r, e, i, u - 1, -u);
      }
      var a = 0, E = 1, B = 0;
      for (this[e] = r & 255; ++a < i && (E *= 256); )
        r < 0 && B === 0 && this[e + a - 1] !== 0 && (B = 1), this[e + a] = (r / E >> 0) - B & 255;
      return e + i;
    }, o.prototype.writeIntBE = function(r, e, i, n) {
      if (r = +r, e = e >>> 0, !n) {
        var u = Math.pow(2, 8 * i - 1);
        M(this, r, e, i, u - 1, -u);
      }
      var a = i - 1, E = 1, B = 0;
      for (this[e + a] = r & 255; --a >= 0 && (E *= 256); )
        r < 0 && B === 0 && this[e + a + 1] !== 0 && (B = 1), this[e + a] = (r / E >> 0) - B & 255;
      return e + i;
    }, o.prototype.writeInt8 = function(r, e, i) {
      return r = +r, e = e >>> 0, i || M(this, r, e, 1, 127, -128), r < 0 && (r = 255 + r + 1), this[e] = r & 255, e + 1;
    }, o.prototype.writeInt16LE = function(r, e, i) {
      return r = +r, e = e >>> 0, i || M(this, r, e, 2, 32767, -32768), this[e] = r & 255, this[e + 1] = r >>> 8, e + 2;
    }, o.prototype.writeInt16BE = function(r, e, i) {
      return r = +r, e = e >>> 0, i || M(this, r, e, 2, 32767, -32768), this[e] = r >>> 8, this[e + 1] = r & 255, e + 2;
    }, o.prototype.writeInt32LE = function(r, e, i) {
      return r = +r, e = e >>> 0, i || M(this, r, e, 4, 2147483647, -2147483648), this[e] = r & 255, this[e + 1] = r >>> 8, this[e + 2] = r >>> 16, this[e + 3] = r >>> 24, e + 4;
    }, o.prototype.writeInt32BE = function(r, e, i) {
      return r = +r, e = e >>> 0, i || M(this, r, e, 4, 2147483647, -2147483648), r < 0 && (r = 4294967295 + r + 1), this[e] = r >>> 24, this[e + 1] = r >>> 16, this[e + 2] = r >>> 8, this[e + 3] = r & 255, e + 4;
    };
    function er(t, r, e, i, n, u) {
      if (e + i > t.length) throw new RangeError("Index out of range");
      if (e < 0) throw new RangeError("Index out of range");
    }
    function tr(t, r, e, i, n) {
      return r = +r, e = e >>> 0, n || er(t, r, e, 4), y.write(t, r, e, i, 23, 4), e + 4;
    }
    o.prototype.writeFloatLE = function(r, e, i) {
      return tr(this, r, e, !0, i);
    }, o.prototype.writeFloatBE = function(r, e, i) {
      return tr(this, r, e, !1, i);
    };
    function ir(t, r, e, i, n) {
      return r = +r, e = e >>> 0, n || er(t, r, e, 8), y.write(t, r, e, i, 52, 8), e + 8;
    }
    o.prototype.writeDoubleLE = function(r, e, i) {
      return ir(this, r, e, !0, i);
    }, o.prototype.writeDoubleBE = function(r, e, i) {
      return ir(this, r, e, !1, i);
    }, o.prototype.copy = function(r, e, i, n) {
      if (!o.isBuffer(r)) throw new TypeError("argument should be a Buffer");
      if (i || (i = 0), !n && n !== 0 && (n = this.length), e >= r.length && (e = r.length), e || (e = 0), n > 0 && n < i && (n = i), n === i || r.length === 0 || this.length === 0) return 0;
      if (e < 0)
        throw new RangeError("targetStart out of bounds");
      if (i < 0 || i >= this.length) throw new RangeError("Index out of range");
      if (n < 0) throw new RangeError("sourceEnd out of bounds");
      n > this.length && (n = this.length), r.length - e < n - i && (n = r.length - e + i);
      var u = n - i;
      return this === r && typeof Uint8Array.prototype.copyWithin == "function" ? this.copyWithin(e, i, n) : Uint8Array.prototype.set.call(
        r,
        this.subarray(i, n),
        e
      ), u;
    }, o.prototype.fill = function(r, e, i, n) {
      if (typeof r == "string") {
        if (typeof e == "string" ? (n = e, e = 0, i = this.length) : typeof i == "string" && (n = i, i = this.length), n !== void 0 && typeof n != "string")
          throw new TypeError("encoding must be a string");
        if (typeof n == "string" && !o.isEncoding(n))
          throw new TypeError("Unknown encoding: " + n);
        if (r.length === 1) {
          var u = r.charCodeAt(0);
          (n === "utf8" && u < 128 || n === "latin1") && (r = u);
        }
      } else typeof r == "number" ? r = r & 255 : typeof r == "boolean" && (r = Number(r));
      if (e < 0 || this.length < e || this.length < i)
        throw new RangeError("Out of range index");
      if (i <= e)
        return this;
      e = e >>> 0, i = i === void 0 ? this.length : i >>> 0, r || (r = 0);
      var a;
      if (typeof r == "number")
        for (a = e; a < i; ++a)
          this[a] = r;
      else {
        var E = o.isBuffer(r) ? r : o.from(r, n), B = E.length;
        if (B === 0)
          throw new TypeError('The value "' + r + '" is invalid for argument "value"');
        for (a = 0; a < i - e; ++a)
          this[a + e] = E[a % B];
      }
      return this;
    };
    var _r = /[^+/0-9A-Za-z-_]/g;
    function Ur(t) {
      if (t = t.split("=")[0], t = t.trim().replace(_r, ""), t.length < 2) return "";
      for (; t.length % 4 !== 0; )
        t = t + "=";
      return t;
    }
    function K(t, r) {
      r = r || 1 / 0;
      for (var e, i = t.length, n = null, u = [], a = 0; a < i; ++a) {
        if (e = t.charCodeAt(a), e > 55295 && e < 57344) {
          if (!n) {
            if (e > 56319) {
              (r -= 3) > -1 && u.push(239, 191, 189);
              continue;
            } else if (a + 1 === i) {
              (r -= 3) > -1 && u.push(239, 191, 189);
              continue;
            }
            n = e;
            continue;
          }
          if (e < 56320) {
            (r -= 3) > -1 && u.push(239, 191, 189), n = e;
            continue;
          }
          e = (n - 55296 << 10 | e - 56320) + 65536;
        } else n && (r -= 3) > -1 && u.push(239, 191, 189);
        if (n = null, e < 128) {
          if ((r -= 1) < 0) break;
          u.push(e);
        } else if (e < 2048) {
          if ((r -= 2) < 0) break;
          u.push(
            e >> 6 | 192,
            e & 63 | 128
          );
        } else if (e < 65536) {
          if ((r -= 3) < 0) break;
          u.push(
            e >> 12 | 224,
            e >> 6 & 63 | 128,
            e & 63 | 128
          );
        } else if (e < 1114112) {
          if ((r -= 4) < 0) break;
          u.push(
            e >> 18 | 240,
            e >> 12 & 63 | 128,
            e >> 6 & 63 | 128,
            e & 63 | 128
          );
        } else
          throw new Error("Invalid code point");
      }
      return u;
    }
    function Ir(t) {
      for (var r = [], e = 0; e < t.length; ++e)
        r.push(t.charCodeAt(e) & 255);
      return r;
    }
    function Sr(t, r) {
      for (var e, i, n, u = [], a = 0; a < t.length && !((r -= 2) < 0); ++a)
        e = t.charCodeAt(a), i = e >> 8, n = e % 256, u.push(n), u.push(i);
      return u;
    }
    function nr(t) {
      return p.toByteArray(Ur(t));
    }
    function z(t, r, e, i) {
      for (var n = 0; n < i && !(n + e >= r.length || n >= t.length); ++n)
        r[n + e] = t[n];
      return n;
    }
    function k(t, r) {
      return t instanceof r || t != null && t.constructor != null && t.constructor.name != null && t.constructor.name === r.name;
    }
    function J(t) {
      return t !== t;
    }
    var Cr = function() {
      for (var t = "0123456789abcdef", r = new Array(256), e = 0; e < 16; ++e)
        for (var i = e * 16, n = 0; n < 16; ++n)
          r[i + n] = t[e] + t[n];
      return r;
    }();
  }(G)), G;
}
var P = { exports: {} }, cr;
function zr() {
  return cr || (cr = 1, function(x, p) {
    var y = function() {
      if (typeof self < "u")
        return self;
      if (typeof window < "u")
        return window;
      if (typeof ar < "u")
        return ar;
      throw new Error("unable to locate global object");
    }, g = y();
    x.exports = p = g.fetch, g.fetch && (p.default = g.fetch.bind(g)), p.Headers = g.Headers, p.Request = g.Request, p.Response = g.Response;
  }(P, P.exports)), P.exports;
}
var O = { exports: {} }, lr;
function Wr() {
  if (lr) return O.exports;
  lr = 1;
  const { AbortController: x, AbortSignal: p } = typeof self < "u" ? self : typeof window < "u" ? window : (
    /* otherwise */
    void 0
  );
  return O.exports = x, O.exports.AbortSignal = p, O.exports.default = x, O.exports;
}
var V, wr;
function Hr() {
  return wr || (wr = 1, V = { Logger: kr()(
    typeof Blob < "u" ? Blob : Or().Blob,
    typeof fetch < "u" ? fetch : zr(),
    typeof AbortController < "u" ? AbortController : Wr()
  ) }), V;
}
var Pr = Hr();
const Kr = /* @__PURE__ */ Rr(Pr), Vr = (x) => {
  const {
    serverUrl: p = "https://seq.oncoreflex.dev",
    apiKey: y,
    tags: g,
    redirectError: F = !1,
    redirectWarn: v = !1,
    redirectInfo: l = !1,
    children: o
  } = x, T = qr(() => new Kr.Logger({
    serverUrl: p,
    apiKey: y,
    onError: (h) => N(h)
  }), [p, y]);
  Dr(() => () => {
    T.flush().then();
  });
  const C = (h, f, w) => {
    try {
      T.emit({
        level: h,
        timestamp: /* @__PURE__ */ new Date(),
        messageTemplate: f,
        properties: {
          ...g,
          ...w
        }
      });
    } catch (s) {
      N(s);
    }
  };
  return console.error = F ? function(...h) {
    try {
      h.forEach((f) => C("Error", f));
    } catch (f) {
      N(f);
    }
    N(...h);
  } : N, console.warn = v ? function(...h) {
    try {
      h.forEach((f) => C("Warning", f));
    } catch (f) {
      Y(f);
    }
    Y(...h);
  } : Y, console.info = l ? function(...h) {
    try {
      h.forEach((f) => C("Information", f));
    } catch (f) {
      $(f);
    }
    $(...h);
  } : $, /* @__PURE__ */ Lr.jsx(Mr.Provider, { value: {
    log: (h, f, w) => C(h, f, w)
  }, children: o });
};
export {
  Vr as LoggingProvider,
  jr as useLogging
};
